import { repositories } from '../api/createRepositories';

const voicesRepository = repositories.voices;

export const voicesService = {
  getVoices: async (options = {}) => {
    return await voicesRepository.getVoices(options);
  },

  getVoiceById: async (voiceId) => {
    return await voicesRepository.getVoiceById(voiceId);
  },

  deleteVoice: async (voiceId) => {
    return await voicesRepository.deleteVoice(voiceId);
  },

  findSimilarVoices: async (request) => {
    return await voicesRepository.findSimilarVoices(request);
  },

  editVoice: async (voiceId, voiceData) => {
    return await voicesRepository.editVoice(voiceId, voiceData);
  }
};

export const {
  getVoices,
  getVoiceById,
  deleteVoice,
  findSimilarVoices,
  editVoice
} = voicesService;

export default voicesService;